export default __webpack_public_path__ + "static/media/main.dde11433.jpg";